import styled, { css } from 'styled-components';
import { Close } from '@styled-icons/evil';
import Markdown from '@common/components/Markdown';
import SectionContainer from '@common/components/SectionContainer';
import { Heading4 } from '@common/components/Typography';
import getContrastFontColor from '@utils/getContrastFontColor';
import { token } from 'odyssey';
import { rgba } from 'polished';

export const StyledBanner = styled.div`
  background: ${({ theme }) => theme.customColors.primary};

  ${({ theme }) =>
    theme.customColors.primary === theme.customColors.header &&
    css`
      border-top: 1px solid
        ${rgba(
          getContrastFontColor(
            theme.customColors.primary,
            theme.defaultColors.fontPrimary,
            theme.defaultColors.lighterGrey
          ),
          0.3
        )};
    `};
`;

export const Heading = styled(Heading4)`
  font-size: 18px;
  margin-bottom: 0;
  color: ${({ theme }) =>
    getContrastFontColor(
      theme.customColors.primary,
      theme.defaultColors.fontPrimary,
      theme.defaultColors.lighterGrey
    )};
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  padding-right: 2.063rem;
  gap: ${token('space-3')};
`;

export const Container = styled(SectionContainer)`
  display: flex;
  padding-top: 1.1rem;
  padding-bottom: 1.1rem;
  gap: 1rem;
  justify-content: space-between;
`;

export const Dismiss = styled.button`
  position: absolute;
  top: 50%;
  right: 0.875rem;
  transform: translateY(-50%);
  flex-shrink: 0;
  border: 0;
  background: transparent;
  padding: 0;
`;

export const CloseIcon = styled(Close)`
  color: ${({ theme }) =>
    getContrastFontColor(
      theme.customColors.primary,
      theme.defaultColors.fontPrimary,
      theme.defaultColors.lighterGrey
    )};
  width: 1.875rem;
  height: 1.875rem;
  flex-shrink: 0;
  cursor: pointer;
`;

export const StyledMarkdown = styled(Markdown)`
  color: ${({ theme }) =>
    getContrastFontColor(
      theme.customColors.primary,
      theme.defaultColors.fontPrimary,
      theme.defaultColors.lighterGrey
    )};

  & p {
    margin-bottom: 0;
  }

  & a {
    color: ${({ theme }) =>
      getContrastFontColor(
        theme.customColors.primary,
        theme.defaultColors.fontPrimary,
        theme.defaultColors.lighterGrey
      )};
    text-decoration: underline;
  }
`;
